import { ApiConfig } from '../types';

// Default API configuration for Pro Images component
const DEFAULT_PRO_IMAGE_API_CONFIG: ApiConfig = {
  endpoint: 'GetProImages',
  buildQueryParams: (proNumber: string) => {
    return `proId=${proNumber}`;
  },
  transformConfig: {
    fields: ['bolImages', 'proofOfPickupImages'],
    labelMappings: {
      bolImages: 'BOL Images',
      proofOfPickupImages: 'Proof Of Pickup'
    }
  }
};

// Gets the default Pro Images API config
export const getDefaultProImageAPIConfig = (): ApiConfig => {
  return DEFAULT_PRO_IMAGE_API_CONFIG;
};
